import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr";

// Connects to data-controller="booking-form"
export default class extends Controller {
  static targets = ["dateInput", "bookingTypeSelect"]

  connect() {
    this.fetchDates(this.bookingTypeSelectTarget.value)

    this.bookingTypeSelectTarget.addEventListener("change", this.fetchDates.bind(this));
  }

  fetchDates() {
    const selectedBookingType = this.bookingTypeSelectTarget.value
    fetch(`/bookings/dates?booking_type=${selectedBookingType}`)
      .then(response => response.json())
      .then(data => {
        if (this.datePicker) {
          this.dateInputTarget.value = "";
          this.datePicker.destroy();
        }
        this.datePicker = flatpickr(this.dateInputTarget, {
          enableTime: false,
          enable: data.dates
        });
      });
  }
}
